export default __webpack_public_path__ + "static/media/girlFloating@2x.74893ab2.png";